module.exports = __webpack_public_path__ + "static/media/batch-focused.39a5968c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/batch-focused.svg
// module id = 1235
// module chunks = 0